
































import Vue from "vue";
import { GET_SPEED_OPTIONS, AUDIO_CONFIRMATIONS_URL } from "@tt-app/constants";
import {
  FormOptions,
  UserProfileAudioConfig,
  AudioSpeed,
  AudioAccent,
  AudioGender
} from "@tt-app/models";
import { AudioDecoderPlayer } from "@joyz/app-core/utils/audio";
import { audioContext } from "@tt-app/utils/audio/audioContext";

import IconSpeedMetre from "@joyz/app-core/assets/icons/default/Speed.svg";
import IconRabbit from "@joyz/app-core/assets/icons/misc/Rabbit.svg";
import IconTortoise from "@joyz/app-core/assets/icons/misc/Tortise.svg";

interface Data {
  audioDecoderPlayer: AudioDecoderPlayer;
  model: number;
}

interface Methods {
  refreshAudioPlayer: () => void;
}

interface Computed {
  options: FormOptions<number>[];
  iconTitle: string;
  iconLeft: string;
  iconRight: string;
}

interface Props {
  audioConfig: UserProfileAudioConfig;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "SpeechSpeedCard",

  props: {
    audioConfig: {
      type: Object as () => UserProfileAudioConfig,
      required: true
    }
  },

  created() {
    document.addEventListener("visibilitychange", this.refreshAudioPlayer);
  },

  data() {
    return {
      audioDecoderPlayer: new AudioDecoderPlayer({ audioContext }),
      model: this.audioConfig.speed
    };
  },

  methods: {
    refreshAudioPlayer() {
      if (document.visibilityState === "visible") {
        console.log("refreshing audio player");
        this.audioDecoderPlayer = new AudioDecoderPlayer({ audioContext });
      }
    }
  },

  computed: {
    options() {
      return GET_SPEED_OPTIONS(this);
    },
    iconTitle: () => IconSpeedMetre,
    iconLeft: () => IconTortoise,
    iconRight: () => IconRabbit
  },

  watch: {
    model: {
      async handler(newVal: AudioSpeed) {
        const accent: AudioAccent = this.audioConfig.accent;
        const speed: AudioSpeed = newVal;
        const gender: AudioGender = "F";

        if (this.audioDecoderPlayer.status === "playing") {
          this.audioDecoderPlayer.stop();
        }

        const sample: string = AUDIO_CONFIRMATIONS_URL[accent][gender][speed];
        await audioContext.resume();
        await this.audioDecoderPlayer.play(sample);
      }
    }
  },

  beforeDestroy() {
    this.audioDecoderPlayer.destroy();
    document.removeEventListener("visibilitychange", this.refreshAudioPlayer);
  }
});
